module.exports = __webpack_public_path__ + "img/david2.bdd1fefd.jpg";